import React from 'react';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import {List} from 'immutable';
import CoachingReviewFileUpload from 'records/CoachingReviewFileUpload';
import CoachingContentDetailScore from 'records/CoachingContentDetailScore';
import Button from '@material-ui/core/Button';
import './AddToPlanQuickAction.styl';
import classNames from 'classnames';

export default class AddToPlanQuickAction extends React.PureComponent {
  render() {
    const {reviewFileUploads, plan, review, fileUploadId, authUser, shouldFlash} = this.props;
    const alreadyAdded = reviewFileUploads.some(
      // yes the case here is correct
      r => r.fileuploadId === fileUploadId
    );

    return (
      <div className="coaching-quick-actions add-to-plan-quick-action">
        {alreadyAdded ? null : (
          <Button
            variant="outlined"
            size="small"
            fullWidth
            className={classNames('ev-button', shouldFlash && 'flash-button')}
            onClick={() =>
              plan &&
              review &&
              CoachingReviewActions.updateReviewFileUploads(
                review.id,
                List([
                  new CoachingReviewFileUpload({
                    fileuploadId: fileUploadId,
                    addedByUserId: List([authUser.id]),
                    reviewFeedbackList: plan.contentDetails.map(
                      detail =>
                        new CoachingContentDetailScore({
                          contentDetailId: detail.id,
                        })
                    ),
                  }),
                ])
              )
            }>
            Add To Plan
          </Button>
        )}
      </div>
    );
  }
}
